import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TuiDropdown, TuiButton, TuiHint } from '@taiga-ui/core';
import { TuiDropdownMobile } from '@taiga-ui/addon-mobile';

import { DropdownButtonComponent } from './dropdown-button.component';

@NgModule({
  declarations: [DropdownButtonComponent],
  imports: [CommonModule, ...TuiDropdown, TuiDropdownMobile, TuiButton, ...TuiHint],
  exports: [DropdownButtonComponent],
})
export class DropdownButtonModule {}
